import state from '~store/modules/notifications/state'
import actions from '~store/modules/notifications/actions'

export default {
  state,
  actions
}
